import e from"../../../../../../../prop-types/index.js";var o=e.oneOfType([e.func,e.object]);export{o as default};
//# sourceMappingURL=refType.js.map
